import React from 'react';
import { withTranslation } from 'react-i18next';
import Backend from '../../../../Layouts/Backend';
import { Formik } from 'formik';
import { Row, Col, Form } from 'reactstrap';
import validationSchema from './validation';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import helper from '../../../../../utils/helper';
import {
  Input,
  Dropdown,
  Button,
  Alert,
  Checkbox,
} from '../../../../UI/Common';

const NewRemoteDevicePage = (props) => {
  const { t, isSubmitting } = props;
  const form = {
    // deptId: '',
    serialNo: '',
    sensorPollRate: '',
    alarmUpdate: '',
    description: '',
    mktActivationEnergy: '',
    audible: false,
    active: false,
  };
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onCreateRemoteDevice(values);
    }
  }
  return (
    <Backend>
      <div className="content-inner">
        <Row>
          <Col xs={10} md={6}>
            <Formik
              enableReinitialize
              initialValues={form}
              validationSchema={validationSchema}
              onSubmit={(values) => onSubmit(values)}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                setFieldValue,
                touched,
                handleSubmit,
              }) => {
                return (
                  <Form>
                    <PasswordConfirmation
                      isOpen={openModal}
                      onCancel={() => setOpenModal(false)}
                      onConfirm={() => {
                        setOpenModal(false);
                        props.onCreateRemoteDevice(values);
                      }}
                    />
                    {/* <Dropdown
                      type="dynamic"
                      includeZero
                      label="Department"
                      data={departments}
                      value={values.deptId}
                      onChange={({ value, text }) => {
                        setFieldTouched('deptId', false);
                        setFieldValue('deptId', value);
                      }}
                      valueKey="id"
                      nameKey="name"
                      invalid={touched.deptId}
                      error={errors.deptId}
                    /> */}
                    <Input
                      required
                      id="serialNo"
                      label="Serial Number"
                      onChange={handleChange('serialNo')}
                      value={values.serialNo}
                      invalid={touched.serialNo}
                      error={errors.serialNo}
                    />
                    <Input
                      required
                      id="sensorPollRate"
                      label="Normal Update (sec)"
                      onChange={handleChange('sensorPollRate')}
                      value={values.sensorPollRate}
                      invalid={touched.sensorPollRate}
                      error={errors.sensorPollRate}
                    />
                    <Input
                      required
                      id="alarmUpdate"
                      label="Alarm Update (sec)"
                      onChange={handleChange('alarmUpdate')}
                      value={values.alarmUpdate}
                      invalid={errors.alarmUpdate && touched.alarmUpdate}
                      error={errors.alarmUpdate}
                    />
                    <Input
                      id="description"
                      label="Description"
                      onChange={handleChange('description')}
                      value={values.description}
                      invalid={errors.description && touched.description}
                      error={errors.description}
                    />
                    <Input
                      required
                      id="mktActivationEnergy"
                      label="MKT Activation Energy"
                      onChange={handleChange('mktActivationEnergy')}
                      value={values.mktActivationEnergy}
                      invalid={touched.mktActivationEnergy}
                      error={errors.mktActivationEnergy}
                    />
                    <Checkbox
                      id="audible"
                      label="Beeper"
                      checked={values.audible}
                      onChange={(isChecked) =>
                        setFieldValue('audible', isChecked)
                      }
                    />
                    <Checkbox
                      id="active"
                      label="Active"
                      checked={values.active}
                      onChange={(isChecked) =>
                        setFieldValue('active', isChecked)
                      }
                    />
                    <Alert.Error text={props.errors} />
                    <Button
                      id="edit-remote-device-btn"
                      loading={isSubmitting}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      <i className="md-icon">done</i>
                      {t('Save')}
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(NewRemoteDevicePage);
